/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TotalSalesSummary
 */
export interface TotalSalesSummary {
    /**
     * 
     * @type {number}
     * @memberof TotalSalesSummary
     */
    ordersAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TotalSalesSummary
     */
    openOrdersAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TotalSalesSummary
     */
    invoiceAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TotalSalesSummary
     */
    creditNoteAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TotalSalesSummary
     */
    canceledInvoiceAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TotalSalesSummary
     */
    canceledOrdersAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TotalSalesSummary
     */
    quota: number;
}

/**
 * Check if a given object implements the TotalSalesSummary interface.
 */
export function instanceOfTotalSalesSummary(value: object): value is TotalSalesSummary {
    if (!('ordersAmount' in value) || value['ordersAmount'] === undefined) return false;
    if (!('openOrdersAmount' in value) || value['openOrdersAmount'] === undefined) return false;
    if (!('invoiceAmount' in value) || value['invoiceAmount'] === undefined) return false;
    if (!('creditNoteAmount' in value) || value['creditNoteAmount'] === undefined) return false;
    if (!('canceledInvoiceAmount' in value) || value['canceledInvoiceAmount'] === undefined) return false;
    if (!('canceledOrdersAmount' in value) || value['canceledOrdersAmount'] === undefined) return false;
    if (!('quota' in value) || value['quota'] === undefined) return false;
    return true;
}

export function TotalSalesSummaryFromJSON(json: any): TotalSalesSummary {
    return TotalSalesSummaryFromJSONTyped(json, false);
}

export function TotalSalesSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TotalSalesSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'ordersAmount': json['ordersAmount'],
        'openOrdersAmount': json['openOrdersAmount'],
        'invoiceAmount': json['invoiceAmount'],
        'creditNoteAmount': json['creditNoteAmount'],
        'canceledInvoiceAmount': json['canceledInvoiceAmount'],
        'canceledOrdersAmount': json['canceledOrdersAmount'],
        'quota': json['quota'],
    };
}

export function TotalSalesSummaryToJSON(json: any): TotalSalesSummary {
    return TotalSalesSummaryToJSONTyped(json, false);
}

export function TotalSalesSummaryToJSONTyped(value?: TotalSalesSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ordersAmount': value['ordersAmount'],
        'openOrdersAmount': value['openOrdersAmount'],
        'invoiceAmount': value['invoiceAmount'],
        'creditNoteAmount': value['creditNoteAmount'],
        'canceledInvoiceAmount': value['canceledInvoiceAmount'],
        'canceledOrdersAmount': value['canceledOrdersAmount'],
        'quota': value['quota'],
    };
}

